import React, { useRef } from 'react';
import cn from 'classnames';
import { Visibility } from '../../../types/common-types';
import useClickOutside from '../effects';
import './style.scss';

export interface MenuProps {
  id?: string;
  onClick: (value: string) => void;
  onClose?: () => void;
  visibility?: Visibility;
  activeItem: string;
  children: React.ReactNodeArray;
  className?: string;
  styleName?: string;
}

const Menu: React.FC<MenuProps> = ({
  id = '',
  activeItem,
  children,
  onClick,
  onClose,
  visibility = Visibility.Visible,
  className,
}) => {
  const wrapperRef = useRef(null);
  const handleClick = (value: string) => {
    if (visibility === Visibility.Visible) {
      onClick(value);
    }
  };
  useClickOutside(wrapperRef, () => {
    if (visibility !== Visibility.Visible) return;
    if (onClose) onClose();
  });
  return (
    <div
      id={id}
      ref={wrapperRef}
      className={className}
      styleName={cn('menu', {
        disabled: visibility === Visibility.Disabled,
        hidden: visibility === Visibility.Hidden,
      })}
    >
      {React.Children.map(children, child => {
        const params = { onClick: handleClick };
        if (activeItem) {
          params.activeItem = activeItem;
        }
        return React.cloneElement(child, params);
      })}
    </div>
  );
};
export default Menu;
